export default {"src":"/_next/static/media/security.b0335a92.svg","height":12,"width":11,"blurWidth":0,"blurHeight":0};